// src/pages/ComingSoon.tsx
// Temporary placeholder page — swapped in for the Client Support portal
// (/client/*) and the Showcase page (/showcase) while work is paused on
// them, so focus stays on the main dashboard + the real Client Portal.
// Reverting is just restoring the original <Route> entries in index.tsx —
// the real pages/components are untouched on disk.
import { Sun, Moon, Clock } from 'lucide-react'
import { useTheme } from '../hooks/useTheme'
import { T } from '../components/ui/UI'

interface ComingSoonProps {
    title?: string
}

export default function ComingSoon({ title = 'RITIS' }: ComingSoonProps) {
    const { theme, toggleTheme } = useTheme()
    const s = styles

    return (
        <div className="jr-app" data-theme={theme} style={s.page}>
            <button
                onClick={toggleTheme}
                aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
                style={s.themeToggle}>
                {theme === 'dark' ? <Sun size={14} /> : <Moon size={14} />}
            </button>

            <div style={s.card}>
                <div style={s.iconWrap}>
                    <Clock size={28} color={T.accent} />
                </div>
                <div style={s.logoRow}>
                    <div style={s.logoDot} />
                    <span style={s.logoText}>{title}</span>
                </div>
                <h1 style={s.title}>Coming Soon</h1>
                <p style={s.sub}>
                    This page is temporarily unavailable while we work on improvements.
                    <br />
                    هذه الصفحة غير متاحة مؤقتًا حاليًا — نعمل على تحسينها.
                </p>
                <p style={s.footer}>
                    Need help? Contact us at{' '}
                    <a href="mailto:support@ritisbase.com" style={s.link}>
                        support@ritisbase.com
                    </a>
                </p>
            </div>
        </div>
    )
}

const styles: Record<string, React.CSSProperties> = {
    page: { minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', position: 'relative' },
    themeToggle: {
        position: 'absolute', top: 20, right: 20, width: 34, height: 34, borderRadius: 8,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        border: `1px solid ${T.borderStrong}`, background: T.surface, color: T.text2, cursor: 'pointer',
    },
    card: {
        width: '100%', maxWidth: 420, background: T.surface, borderRadius: T.radiusLg,
        border: `1px solid ${T.border}`, boxShadow: T.shadowMd, padding: '44px 32px',
        textAlign: 'center' as const,
    },
    iconWrap: {
        width: 56, height: 56, borderRadius: '50%', background: T.accentSoft,
        display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px',
    },
    logoRow: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginBottom: 10 },
    logoDot: { width: 8, height: 8, borderRadius: '50%', background: T.accent },
    logoText: { fontSize: 11, fontWeight: 700, color: T.text2, letterSpacing: 1, textTransform: 'uppercase' as const },
    title: { fontSize: 26, fontWeight: 700, color: T.text, marginBottom: 12 },
    sub: { fontSize: 14, color: T.text2, lineHeight: 1.7, marginBottom: 24 },
    footer: { textAlign: 'center' as const, fontSize: 12, color: T.text3, marginTop: 8 },
    link: { color: T.info, textDecoration: 'none' },
}
